<template>
	<div>


		<div class='nav' :class="[$store.state.navYs?'navs':'']">
			<div class='nav-in'>
				<div class='nav-in-logo'>
					<div class="nav-in-logo-in"></div>
				</div>
				<div class='nav-in-nav'>
					<router-link class="nav-in-nav-item" :class="[item.xz?'navItemXz':'']"
						v-for="(item,index) in $store.state.navArr" :key='index' :to="item.to"
						@click.native="tapNavItem(index,item.name)">
						{{item.name}}
					</router-link>
				</div>
			</div>
		</div>

		<!-- 移动端 -->
		<div class="min-nav">
			<router-link v-for="(item,index) in $store.state.navArr.slice(4).reverse()" :key='index' :to="item.to"
				@click.native="tapNavItem(index,item.name)">
				<div class="min-nav-item">
					<div class="min-nav-item-top">
						<div class="min-nav-item-top-in">
							<img :src="item.icon" style="width: 100%;" v-if="!item.xz">
							<img :src="item.iconxz" style="width: 100%;" v-else>
						</div>
					</div>
					<div class="min-nav-item-text" :class="[item.xz?'navItemXzMin':'']">{{item.name}}</div>
				</div>
			</router-link>
		</div>
		<!-- 移动端结束 -->

	</div>
</template>

<script>
	export default {
		name: 'navs',
		data() {
			return {
				navArr: []
			}
		},
		mounted() {
			let path = this.$route.path;
			// console.log(path)
			this.$store.commit('path', path);
		},
		methods: {
			tapNavItem(index, name) {
				// console.log(index,name);
				if (index == 0 && name == '首页') {
					index = 6;
				} else if (index == 1 && name == '成功案例') {
					index = 5;
				} else if (index == 2 && name == '关于我们') {
					index = 4;
				}
				this.$store.commit('tapNavItem', index);
			}
		}
	}
</script>

<style>
	/* 导航部分 */
	.nav {
		width: 100%;
		height: 110px;
		background: #ffffff;
		opacity: .9;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 1;

	}

	.navs {
		opacity: 1;
		box-shadow: 0px 0px 20px #e6e6e8;
	}

	.nav-in {
		width: 1200px;
		height: 100%;
		/* background: #42B983; */
		margin: 0 auto;
	}

	.nav-in-logo {
		width: 342px;
		height: 100%;
		/* background: pink; */
		float: left;
		position: relative;
	}

	.nav-in-nav {
		width: calc(100% - 342px);
		height: 100%;
		/* background: tan; */
		float: left;
	}

	.nav-in-logo-in {
		width: 342px;
		height: 45px;
		position: absolute;
		top: calc(50% - 22.5px);
		left: 0;
		background-image: url(../assets/logo.png);
		background-size: 100% 100%;
	}

	.nav-in-nav-item {
		width: 100px;
		height: 100%;
		/* background: blue; */
		float: right;
		font-size: 16px;
		color: #444444;
		line-height: 110px;
		text-align: center;
		transition: all .3s;
	}

	.navItemXz {
		color: #ffffff;
		background: #52dedb;
		cursor: pointer;
	}

	.nav-in-nav-item:hover {
		color: #ffffff;
		background: #52dedb;
		cursor: pointer;
		transform: rotate(1.1);
	}

	.min-nav {
		display: none;
	}


	/* 导航部分结束 */


	/* 手机设备和屏幕小于1200px时生效 */
	@media only screen and (max-width: 1200px) {
		.nav {
			display: none;
		}

		.min-nav {
			display: block;
			width: 100%;
			height: 3.125rem;
			background: #ffffff;
			position: fixed;
			bottom: 0;
			left: 0;
			border-top: 1px solid #ededed;
			box-sizing: border-box;
			z-index: 999;
		}

		.min-nav-item {
			width: calc(100% / 3);
			height: 100%;
			float: left;
			text-align: center;
			color: #888888;
			font-size: 0.75rem;
		}

		.navItemXzMin {
			color: #52dedb;
			background: #ffffff;
			cursor: pointer;
			font-weight: bold;
		}

		.min-nav-item-top {
			width: 100%;
			height: 50%;
			/* background: red; */
			position: relative;
		}

		.min-nav-item-top-in {
			width: 1.375rem;
			height: 1.375rem;
			background: tan;
			position: absolute;
			top: 0.3125rem;
			left: calc(50% - 0.625rem);
		}

		.min-nav-item-text {
			width: 100%;
			height: 50%;
			/* background: pink; */
			line-height: 1.75rem
		}


	}
</style>
